import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_URL } from '../../configurations/server-config';
const headers: any = new HttpHeaders({
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*'
});
@Injectable({
  providedIn: 'root'
})
export class CollisService {
  constructor(private http: HttpClient) { }

  saveCollis(collis: any): any {
    return this.http.post(`${API_URL}/createcollis`, collis, {
      observe: 'response',
    });
  }

  updateCollis(collis: any, idcollis: any): any {
    return this.http.put(`${API_URL}/updatecollis/${idcollis}`, collis);
  }
  // get list of all colis
  getAllCollis(page= 0, size= 10, sortby: any=null, orderby: any=null): any {
    return this.http.get(`${API_URL}/collis?page=${page}&size=${size}&sortby=${sortby}&direction=${orderby}`);
  }

  // get list of retrait colis
  getAllColisretrait(page= 0, size= 10, sortby: any=null, orderby: any=null): any {
    return this.http.get(`${API_URL}/collisretrait?page=${page}&size=${size}&sortby=${sortby}&direction=${orderby}`);
  }
  // get collis by destination
  getcollisbydestiantion(id: any, page= 0, size= 50): any {
    return this.http.get(`${API_URL}/collisbydestination/${id}?page=${page}&size=${size}`);
  }
// get collis by destination and status
  getcollisbydestiantionstatus(id: any, page= 0, size= 10): any {
    return this.http.get(`${API_URL}/collisbydestinationstatus/${id}?page=${page}&size=${size}`);
  }

  getcollisbystatus(page= 0, size= 10): any {
    return this.http.get(`${API_URL}/collisbystatus?page=${page}&size=${size}`);
  }

  removecollisfrombordereau(coll: any): any {
    // console.log(coll);
    return this.http.post(`${API_URL}/updatecollisstatus`, coll);
  }

  receptioncollis(coll: any): any {
    return this.http.post(`${API_URL}/receptioncollis`, coll);
  }

  getcollisdetails(coll: any): any {
    return this.http.get(`${API_URL}/getcollisbyid/${coll}`);
  }

  retraitCollis(retrait: { idcollis: any; idreceiver: any; comment: any; idcardnumber: any; }): any {
    return this.http.post(`${API_URL}/retraitcollis`, retrait);
  }

  getcollisinsession(session: any): any {
    return this.http.get(`${API_URL}/collissession/${session}`);
  }

  getamountinsession(session: any): any {
    return this.http.get(`${API_URL}/amountsession/${session}`);
  }

  getallcollisinSession(session: any, page: any, size: any): any {
    return this.http.get(`${API_URL}/collisinsessions/${session}?page=${page}&size=${size}`);
  }

  getcolislogs(page: any, size: any): any {
    return this.http.get(`${API_URL}/colislog?page=${page}&size=${size}`);
  }

  searchsender(name: string): any{
    return this.http.post(`${API_URL}/collis/searchsen?q=${name}`, null);
  }

  searchExternalsender(name: string): any{
    return this.http.post(`${API_URL}/collis/searchexternalsen?q=${name}`, null);
  }

  searchsenderwithsavecolissatus(name: string,destination: any=null): any{
    return this.http.post(`${API_URL}/collis/searchsenwithsavestatus?q=${name}&dest=${destination}`, null);
  }

  searchsennum(name: string): any{
    return this.http.post(`${API_URL}/collis/searchsennum?q=${name}`, null);
  }

  searchExternalsennum(name: string): any{
    return this.http.post(`${API_URL}/collis/searchexternalsennum?q=${name}`, null);
  }

  searchreceiver(name: string): any{
    return this.http.post(`${API_URL}/collis/searchreceiver?q=${name}`, null);
  }

  searchcolisByExternalreceiver(name: string): any{
    return this.http.post(`${API_URL}/collis/searchexternalreceiver?q=${name}`, null);
  }

  searchreceiverwithsavecolisstatus(name: string,destination: any): any{
    return this.http.post(`${API_URL}/collis/searchreceiverwithsavecolisstatus?q=${name}&dest=${destination}`, null);
  }

  searchreceivernum(name: string): any{
    return this.http.post(`${API_URL}/collis/searchreceivernum?q=${name}`, null);
  }

  searchExternalreceivernum(name: string): any{
    return this.http.post(`${API_URL}/collis/searchexternalreceivernum?q=${name}`, null);
  }

  searchreceivernumWithSaveColisStatus(name: string,destination: any): any{
    return this.http.post(`${API_URL}/collis/searchreceivernumwithsavestatus?q=${name}&dest=${destination}`, null);
  }

  searchDescriptionWithSaveColisStatus(name: string,destination: any): any{
    return this.http.post(`${API_URL}/collis/searchdescriptionwithsavecolisstatus?q=${name}&dest=${destination}`, null);
  }

  searchticket(name: string): any{
    return this.http.post(`${API_URL}/collis/searchticket?q=${name}`, null);
  }

  searchExternalticket(name: string): any{
    return this.http.post(`${API_URL}/collis/searchexternalticket?q=${name}`, null);
  }

  searchticketwithsavestatus(name: string,destination: any=null): any{
    return this.http.post(`${API_URL}/collis/searchticketsave?q=${name}&dest=${destination}`, null);
  }

  // customer services
  searchcustomerbynumber(name: string): any{
    return this.http.post(`${API_URL}/customer/searchnumber?q=${name}`, null);
  }

  searchcustomerbyname(name: string): any{
    return this.http.post(`${API_URL}/customer/searchname?q=${name}`, null);
  }

  searchdescription(name: string): any{
    return this.http.post(`${API_URL}/description?q=${name}`, null);
  }

  searchbyColisStatusAndDate(status: any = null, date: any = null): any {
    return this.http.post(`${API_URL}/bordereau/searchdatestatus?q=${status}&d=${date}`, null);
  }

  getcolisdate(): any{
    return this.http.get(`${API_URL}/getcolisdate`);
  }

  quickedit(data: any): any{
    return this.http.post(`${API_URL}/quickedit`, data);
  }

  cancelticket(idcollis: any): any {
      return this.http.post(`${API_URL}/cancelmailticket?id=${idcollis}`, null);
  }

  getColisSummarySession(session: any){
    return this.http.get(`${API_URL}/colissummary?id=${session}`);
  }

  updateComment(id: any,comments: any): any {
    return this.http.post(`${API_URL}/updatecomment`, {idcollis: id,comment: comments});
}
}
